import { render } from "./CustomerFormLong.vue?vue&type=template&id=43fa3a1c"
import script from "./CustomerFormLong.vue?vue&type=script&lang=js"
export * from "./CustomerFormLong.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__